// extracted by mini-css-extract-plugin
export var chevronIcon = "_bq-2";
export var teamName = "_bq-1";
export var teamSwitcherButton = "_bq-0";